export enum EInputType {
  separatedFromYard = 1,
  separatedFromStreet = 2,
  fromYard = 3,
  fromStreet = 4,
}
